'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["status", "children"],
  _excluded2 = ["isOver"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import UIDropZone from 'UIComponents/drop/UIDropZone';
import pick from 'FileManagerCore/utils/pick';
import { SUPPORTED_UI_DROP_ZONE_PROPS } from 'FileManagerCore/constants/propTypes';
import FileDragAndDrop from 'FileManagerCore/components/FileDragAndDrop';
import { jsx as _jsx } from "react/jsx-runtime";
class DropTargetZone extends Component {
  constructor(...args) {
    super(...args);
    this.handleDropFiles = files => {
      this.props.onUpload(files, {
        target: 'file-upload-drop-target'
      });
    };
  }
  render() {
    const _this$props = this.props,
      {
        status,
        children
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const uiDropZoneProps = pick(rest, SUPPORTED_UI_DROP_ZONE_PROPS);
    return /*#__PURE__*/_jsx(FileDragAndDrop, {
      ignoreDropWhenDefaultPrevented: false,
      onDropFiles: this.handleDropFiles,
      children: _ref => {
        let {
            isOver
          } = _ref,
          props = _objectWithoutPropertiesLoose(_ref, _excluded2);
        return /*#__PURE__*/_jsx("div", Object.assign({
          className: 'drop-zone-target' + (isOver ? " is-over" : "")
        }, props, {
          children: /*#__PURE__*/_jsx(UIDropZone, Object.assign({
            use: isOver ? 'hover' : status
          }, uiDropZoneProps, {
            "data-test-id": "file-upload-drop-target",
            children: children
          }))
        }));
      }
    });
  }
}
DropTargetZone.propTypes = {
  children: PropTypes.node,
  status: PropTypes.string.isRequired,
  onUpload: PropTypes.func.isRequired
};
export default DropTargetZone;